module.exports = __webpack_public_path__ + "img/game-coin-icon.63a2456c.png";